import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import { getHomeServiceEstimate } from '@encarpkg/api';
import * as api from 'app/api';
import produce from 'immer';
import set from 'lodash/set';
import makeDetailFlagsConvert from '../converter/cars';

const CHANGE_VALUE = 'cars/CHANGE_VALUE';
export const changeValue = createAction(CHANGE_VALUE);

const getCarBaseAndEncarCheck = async (carId) => {
	const errorWrapGetEncarCheckSummary = async () => {
		try {
			const res = await api.getInspectSummaryForEncarCheck(carId);
			return {
				...res?.data,
				result: true,
			};
		} catch (error) {
			return {
				result: false,
			};
		}
	};

	let baseResponse = await api.getCarsBase(carId);
	if (baseResponse?.data?.advertisement?.encarCheck) {
		const encarCheckResponse = await errorWrapGetEncarCheckSummary();
		baseResponse = {
			...baseResponse,
			data: {
				...baseResponse.data,
				advertisement: {
					...baseResponse.data.advertisement,
					encarCheck: encarCheckResponse.result,
				},
				encarCheck: { ...encarCheckResponse },
			},
		};
	}

	return baseResponse;
};

const GET_BASE = 'cars/GET_BASE';
export const getBase = createAction(GET_BASE, getCarBaseAndEncarCheck);

const GET_EXPLAIN = 'cars/GET_EXPLAIN';
export const getExplain = createAction(GET_EXPLAIN, api.getCarsExplain);

const GET_SELLINGPOINT = 'cars/GET_SELLINGPOINT';
export const getSellingpoint = createAction(GET_SELLINGPOINT, api.getCarsSellingpoint);

const GET_PHOTO = 'cars/GET_PHOTO';
export const getPhoto = createAction(GET_PHOTO, api.getPhoto);

const GET_DIAGNOSIS = 'cars/GET_DIAGNOSIS';
export const getDiagnosis = createAction(GET_DIAGNOSIS, api.getCarsDiagnosis);

const GET_INSPECT = 'cars/GET_INSPECT';
export const getInspect = createAction(GET_INSPECT, api.getCarsInspect);

const GET_INSPECT_SUMMARY = 'cars/GET_INSPECT_SUMMARY';
export const getInspectSummary = createAction(GET_INSPECT_SUMMARY, api.getCarsInspectSummary);

const GET_OPTION = 'cars/GET_OPTION';
export const getOption = createAction(GET_OPTION, api.getCarsOption);

const GET_OPTION_STANDARD = 'cars/GET_OPTION_STANDARD';
export const getOptionStandard = createAction(GET_OPTION_STANDARD, api.getCarsOptionStandard);

const GET_OPTION_STANDARD_TRUCK = 'cars/GET_OPTION_STANDARD_TRUCK';
export const getOptionStandardTruck = createAction(GET_OPTION_STANDARD_TRUCK, api.getCarsOptionTruckStandard);

const GET_OPTION_CHOICE = 'cars/GET_OPTION_CHOICE';
export const getOptionChoice = createAction(GET_OPTION_CHOICE, api.getCarsOptionChoice);

const GET_OPTION_TUNING = 'cars/GET_OPTION_TUNING';
export const getOptionTuning = createAction(GET_OPTION_TUNING, api.getCarsOptionTuning);

const GET_ACCIDENTSUMMARY = 'cars/GET_ACCIDENTSUMMARY';
export const getAccidentSummary = createAction(GET_ACCIDENTSUMMARY, api.getCarAccidentSummary);

const GET_ACCIDENTOPEN = 'cars/GET_ACCIDENTOPEN';
export const getAccidentOpen = createAction(GET_ACCIDENTOPEN, api.getCarAccidentOpen);

const GET_EXTENDWARRANTY = 'cars/GET_EXTENDWARRANTY';
export const getExtendWarranty = createAction(GET_EXTENDWARRANTY, api.getCarExtendWarranty);

const GET_LEASE_SUCCESSION = 'cars/GET_LEASE_SUCCESSION';
export const getLeaseSuccession = createAction(GET_LEASE_SUCCESSION, api.getCarLeaseSuccession);

const GET_RENT = 'cars/GET_RENT';
export const getRent = createAction(GET_RENT, api.getCarRent);

const GET_RENT_SUCCESSION = 'cars/GET_RENT_SUCCESSION';
export const getRentSuccession = createAction(GET_RENT_SUCCESSION, api.getCarRentSuccession);

const GET_PROFILE = 'cars/GET_PROFILE';
export const getProfile = createAction(GET_PROFILE, api.getUsersProfile);

const GET_MOCHA_DETAIL = 'cars/GET_MOCHA_DETAIL';
export const getMochaDetail = createAction(GET_MOCHA_DETAIL, api.getMochaDetail);

const GET_MOCHA_REQUEST = 'cars/GET_MOCHA_REQUEST';
export const getMochaRequest = createAction(GET_MOCHA_REQUEST, api.getMochaRequest);

const GET_USERS_FAVORITES = 'cars/GET_USERS_FAVORITES';
export const getUsersFavorites = createAction(GET_USERS_FAVORITES, api.getUsersFavorites);

const POST_USERS_FAVORITE = 'request/POST_USERS_FAVORITE';
export const postUsersFavorite = createAction(POST_USERS_FAVORITE, api.postUsersFavorite);

const CANCEL_USERS_FAVORITE = 'request/CANCEL_USERS_FAVORITE';
export const cancelUsersFavorite = createAction(CANCEL_USERS_FAVORITE, api.cancelUsersFavorite);

const POST_LOAN_JUDGEMENT = 'request/POST_LOAN_JUDGEMENT';
export const postLoanJudgement = createAction(POST_LOAN_JUDGEMENT, api.postLoanJudgement);

const GET_LOGGED_AUTH = 'cars/GET_LOGGED_AUTH';
export const getLoggedAuth = createAction(GET_LOGGED_AUTH, api.getLoggedAuth);

const GET_CHECK_FALSECAR = 'cars/GET_CHECK_FALSECAR';
export const getCheckFalseCar = createAction(GET_CHECK_FALSECAR, api.getCheckFalseCar);

const GET_ITEMS = 'cars/GET_ITEMS';
export const getItems = createAction(GET_ITEMS, api.getCarsItems);

const REFRESH = 'cars/REFRESH';
export const refresh = createAction(REFRESH);

const GET_ACQUISITION_COST = 'cars/GET_ACQUISITION_COST';
export const getAcquisitionCost = createAction(GET_ACQUISITION_COST, api.getAcquisitionCost);

const GET_ADDRESS = 'cars/GET_ADDRESS';
export const getAddress = createAction(GET_ADDRESS, api.getSearchAddressList);

const GET_ESTIMATE = 'cars/GET_ESTIMATE';
export const getEstimate = createAction(GET_ESTIMATE, getHomeServiceEstimate);

const GET_ESCROW_CAR_EXISTENCE = 'cars/GET_ESCROW_CAR_EXISTENCE';
export const getEscrowCarExistence = createAction(GET_ESCROW_CAR_EXISTENCE, api.getEscrowCarExistence);

const POST_ENCARPAY_LIMIT_CHECK = 'cars/POST_ENCARPAY_LIMIT_CHECK';
export const postEncarpayLimitCheck = createAction(POST_ENCARPAY_LIMIT_CHECK, api.postEncarpayLimitCheck);

const GET_ENCARPAY_ACTIVATED_FINANCIAL = 'cars/GET_ENCARPAY_ACTIVATED_FINANCIAL';
export const getEncarpayActivatedFinancial = createAction(GET_ENCARPAY_ACTIVATED_FINANCIAL, api.getEncarpayActivatedFinancial);

const POST_NEW_CAR_PRICE_ACCESS_KEY = 'cars/POST_NEW_CAR_PRICE_ACCESS_KEY';
export const postNewCarPriceAccessKey = createAction(POST_NEW_CAR_PRICE_ACCESS_KEY, api.postNewCarPriceAccessKey);

const GET_PARTNER_CENTER = 'cars/GET_PARTNER_CENTER';
export const getPartnerCenter = createAction(GET_PARTNER_CENTER, api.getPartnerCenter);

const GET_AFFILIATION_COMPANY = 'cars/GET_AFFILIATION_COMPANY';
export const getAffiliationCompany = createAction(GET_AFFILIATION_COMPANY, api.getAffiliationCompanyInfo);

const GET_EV_BATTERY = 'cars/GET_EV_BATTERY';
export const getEvBattery = createAction(GET_EV_BATTERY, api.getEvBattery);

const initialState = {
	isRefresh: false,
	detailFlags: null,
	base: {},
	explain: {},
	sellingpoint: {},
	photo: [],
	diagnosis: {
		items: [],
	},
	inspect: {},
	inspectSummary: {},
	option: {},
	optionStandard: {},
	optionStandardTruck: {},
	optionChoice: [],
	optionTuning: [],
	accident: {},
	warranty: {},
	leaseSuccession: [],
	rent: {},
	rentSuccession: [],
	profile: {},
	mochaFaq: {},
	mochaRequest: {},
	usersFavorites: [],
	loggedAuth: {},
	falseCar: {},
	items: [],
	acquisitionCost: {},
	address: [],
	estimate: {},
	encarpayLimitCheck: null,
	escrow: {
		existence: null,
	},
	encarpayAcitvatedFinancial: [{ inflowType: '', financialCompany: '' }],
	inquiryOpen: false,
	newCarPriceAccessKey: '',
	partnerCenter: null,
	affiliationCompany: null,
	userSelectRentValue: { amount: '', month: '', contractType: '' },
	evBattery: {},
};

export default handleActions(
	{
		[REFRESH]: (state) =>
			produce(state, (draft) => {
				draft.isRefresh = true;
			}),
		[CHANGE_VALUE]: (state, action) =>
			produce(state, (draft) => {
				const { schema, name, value } = action.payload;
				set(draft, [...schema, name], value);
			}),

		...pender({
			type: GET_BASE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data, config } = action.payload;
					// const base = (data === '') ? [] : data[0];
					draft.base = data || {};
					draft.base.requestUrl = config.url;

					draft.detailFlags = makeDetailFlagsConvert({ base: data });
				}),
		}),

		...pender({
			type: GET_EXPLAIN,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.explain = data || {};
				}),
		}),

		...pender({
			type: GET_SELLINGPOINT,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.sellingpoint = data || {};
				}),
		}),

		...pender({
			type: GET_PHOTO,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.photo = data.carPhotoInfoList || [];
				}),
		}),

		...pender({
			type: GET_DIAGNOSIS,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.diagnosis = data || {};
				}),
		}),

		...pender({
			type: GET_INSPECT,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.inspect = data || {};
				}),
		}),

		...pender({
			type: GET_INSPECT_SUMMARY,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.inspectSummary = data || {};
				}),
		}),

		...pender({
			type: GET_OPTION,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.option = data || {};
				}),
		}),

		...pender({
			type: GET_OPTION_STANDARD,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.optionStandard = data || {};
				}),
		}),

		...pender({
			type: GET_OPTION_STANDARD_TRUCK,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.optionStandardTruck = data || {};
				}),
		}),

		...pender({
			type: GET_OPTION_CHOICE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.optionChoice = data || [];
				}),
		}),

		...pender({
			type: GET_OPTION_TUNING,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.optionTuning = data || [];
				}),
		}),

		...pender({
			type: GET_ACCIDENTSUMMARY,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.accidentSummary = data || {};
				}),
		}),

		...pender({
			type: GET_ACCIDENTOPEN,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.accident = data || {};
				}),
		}),

		...pender({
			type: GET_EXTENDWARRANTY,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.warranty = data || {};
				}),
		}),

		...pender({
			type: GET_LEASE_SUCCESSION,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.leaseSuccession = data || [];
				}),
		}),

		...pender({
			type: GET_RENT,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.rent = data || {};
				}),
		}),

		...pender({
			type: GET_RENT_SUCCESSION,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.rentSuccession = data || [];
				}),
		}),

		...pender({
			type: GET_PROFILE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.profile = data || {};
				}),
		}),

		...pender({
			type: GET_MOCHA_DETAIL,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.mochaFaq = data || {};
				}),
		}),

		...pender({
			type: GET_MOCHA_REQUEST,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.mochaRequest = data || {};
				}),
		}),

		...pender({
			type: GET_USERS_FAVORITES,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.usersFavorites = data || [];
				}),
		}),

		...pender({
			type: POST_USERS_FAVORITE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.usersFavorite = data || {};
				}),
		}),

		...pender({
			type: CANCEL_USERS_FAVORITE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.cancelFavorite = data || {};
				}),
		}),

		...pender({
			type: POST_LOAN_JUDGEMENT,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.loanJudgement = data || {};
				}),
		}),

		...pender({
			type: GET_LOGGED_AUTH,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.loggedAuth = data || {};
				}),
		}),

		...pender({
			type: GET_CHECK_FALSECAR,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.falseCar = data || {};
				}),
		}),

		...pender({
			type: GET_ITEMS,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.items = data || [];
				}),
		}),

		...pender({
			type: GET_ACQUISITION_COST,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.acquisitionCost = data || {};
				}),
		}),

		...pender({
			type: GET_ADDRESS,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.address = data || [];
				}),
		}),

		...pender({
			type: GET_ESTIMATE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.estimate = data || {};
				}),
		}),
		...pender({
			type: GET_ESCROW_CAR_EXISTENCE,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;

					draft.escrow = data;
				}),
		}),

		...pender({
			type: POST_ENCARPAY_LIMIT_CHECK,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.encarpayLimitCheck = data;
				}),
		}),

		...pender({
			type: GET_ENCARPAY_ACTIVATED_FINANCIAL,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.encarpayAcitvatedFinancial = data;
				}),
		}),

		...pender({
			type: POST_NEW_CAR_PRICE_ACCESS_KEY,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.newCarPriceAccessKey = data;
				}),
		}),

		...pender({
			type: GET_PARTNER_CENTER,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.partnerCenter = data;
				}),
		}),

		...pender({
			type: GET_AFFILIATION_COMPANY,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.affiliationCompany = data;
				}),
		}),

		...pender({
			type: GET_EV_BATTERY,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.evBattery = data || {};
				}),
		}),
	},
	initialState,
);
